import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SmartInsightsFacade } from './smart-insights.facade';
import { DashboardPageDefinition } from '../../dashboard.data';
import { DashboardVmState } from '../../domain/model/dashboard-vm.model';
import { SmartInsightRowVm, SmartInsightType, SmartInsightsVm } from '../../domain/model/smart-insights.model';

/** Smart insights page: what needs the partner's attention now, one row per insight that fires. */
@Component({
  selector: 'ifbp-smart-insights',
  templateUrl: './smart-insights.component.html',
  styleUrls: ['./smart-insights.component.scss'],
  providers: [SmartInsightsFacade],
  standalone: false,
})
export class SmartInsightsComponent implements OnInit {
  page$: Observable<DashboardPageDefinition>;
  vm$: Observable<SmartInsightsVm>;
  readonly VmState = DashboardVmState;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly facade: SmartInsightsFacade,
  ) {}

  ngOnInit(): void {
    this.page$ = this.route.data.pipe(map((data: Data) => data.dashboardPage as DashboardPageDefinition));
    this.vm$ = this.facade.vm$;
  }

  /** A type fires at most once per response. */
  trackByType(_index: number, row: SmartInsightRowVm): SmartInsightType {
    return row.type;
  }
}
